var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNachrichtAbsenden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bankinformationen_",
    "data-name": "Bankinformationen ",
    transform: "translate(-6281 1407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(6281 -1407)",
    fill: "#e8fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-info-outline",
    "data-name": "Icon material-info-outline",
    d: "M25.5,40.5h5v-15h-5ZM28,3A25,25,0,1,0,53,28,25.009,25.009,0,0,0,28,3Zm0,45A20,20,0,1,1,48,28,20.027,20.027,0,0,1,28,48ZM25.5,20.5h5v-5h-5Z",
    transform: "translate(6303 -1385)",
    fill: "#00c4de"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNachrichtAbsenden);
export default __webpack_public_path__ + "static/media/Nachricht_absenden.82675f6967a603c97aaec587f44b56b0.svg";
export { ForwardRef as ReactComponent };